// Tequila / Mezcal / Sotol lineup for the 1st Annual Aloha Tequila & Arts Festival.
// Source: Tamura's official event pricing sheet (6.16.2026). De-duped and grouped by brand.
//
// Each expression carries:
//   - name:  expression label (Blanco / Reposado / Añejo / Roble Fino / etc.)
//   - vip:   true if this specific pour is only available in the VIP area (Moani's)
//   - price: approximate retail price (USD) for the 750ml bottle at Tamura's
//   - size:  bottle size (default 750ml — only called out when different e.g. 1L)
//   - table: per-expression table override (only set when it differs from the brand-level `table`)
//
// Each brand carries a `table` field with the booth / area where the brand's main
// pours are served. VIP-only expressions (vip:true) are always served at Moani's
// VIP Section regardless of the brand-level table.

// Booth reference (see /map):
//   Main Floor (Queens Court): #3 Pernod · #4 Suntory · #5 BF / Suntory Health
//                              · #7 Campari · #10 Proximo · #11 Main Bar
//   3rd Floor Walkway:         #16 RNDC
//   3rd Floor Golf Zone:       #19 Kapena Power · #20 Main Bar · #23 La Marea
//   Moani's VIP (3rd Floor):   VIP-only pours

export const TEQUILA_LINEUP = [
  // ── HOST BRAND / VIP-FORWARD POURS (Moani's VIP) ─────────────────────────────
  { name: "Real del Valle", category: "Tequila", website: "https://rdvtequila.com", table: "VIP · Moani's (3rd Floor)",
    expressions: [
      { name: "Blanco",   vip: true, price: 28.99 },
      { name: "Reposado", vip: true, price: 29.99 },
    ]},

  { name: "Tequila Ocho", category: "Tequila", website: "https://tequilaocho.com", table: "VIP · Moani's (3rd Floor)",
    expressions: [
      { name: "Añejo", vip: true },
    ]},

  { name: "Komos", category: "Tequila", website: "https://komos.com", table: "VIP · Moani's (3rd Floor)",
    expressions: [
      { name: "Rosa",         vip: true, price: 124.99 },
      { name: "Añejo",        vip: true, price: 158.99 },
      { name: "Extra Añejo",  vip: true, price: 469.99 },
      { name: "Cristalino",   vip: true, price: 149.99 },
    ]},

  { name: "Don Fulano", category: "Tequila", website: "https://donfulano.com", table: "VIP · Moani's (3rd Floor)",
    expressions: [
      { name: "Blanco",   vip: true, price: 55.99 },
      { name: "Fuerte",   vip: true, price: 60.99 },
      { name: "Reposado", vip: true, price: 60.99 },
      { name: "Añejo",    vip: true, price: 84.99 },
    ]},

  { name: "G4 Tequila", category: "Tequila", website: "https://g4tequila.com", table: "VIP · Moani's (3rd Floor)",
    expressions: [
      { name: "Blanco",            vip: true, price: 46.99 },
      { name: "Madera",            vip: true, price: 69.99 },
      { name: "Blanco High Proof", vip: true, price: 60.99 },
      { name: "Reposado",          vip: true, price: 55.99 },
      { name: "Añejo",             vip: true, price: 74.99 },
    ]},

  { name: "Cuervo Reserva de la Familia", category: "Tequila", website: "https://cuervo.com", table: "VIP · Moani's (3rd Floor)",
    expressions: [
      { name: "Platino",     vip: true, price: 60.99 },
      { name: "Extra Añejo", vip: true, price: 186.99 },
    ]},

  { name: "Dobel 50", category: "Tequila", website: "https://maestrodobel.com", table: "VIP · Moani's (3rd Floor)",
    expressions: [
      { name: "Extra Añejo", vip: true, price: 154.99 },
    ]},

  { name: "LALO", category: "Tequila", website: "https://lalospirits.com", table: "Table 7 · RNDC (3rd Floor Walkway)",
    expressions: [
      { name: "Blanco", vip: true, price: 45.99 },
    ]},

  // ── PERNOD BAR (Booth #3 — Main Floor) ──────────────────────────────────────
  { name: "Código 1530", category: "Tequila", website: "https://codigo1530.com", table: "Booth #3 · Pernod",
    expressions: [
      { name: "Blanco",   price: 55.99 },
      { name: "Reposado", price: 59.99 },
      { name: "Añejo",    price: 128.99, table: "Booth #4 · Suntory" },
    ]},

  { name: "Olmeca Altos", category: "Tequila", website: "https://olmecaaltos.com", table: "Booth #3 · Pernod",
    expressions: [
      { name: "Plata",    price: 29.99 },
      { name: "Reposado", price: 34.99 },
      { name: "Añejo",    price: 44.99 },
    ]},

  { name: "Del Maguey", category: "Mezcal", website: "https://delmaguey.com", table: "Booth #3 · Pernod",
    expressions: [
      { name: "Vida",    price: 41.99 },
      { name: "Puebla",  price: 49.99 },
      { name: "Pechuga", price: 139.99 },
    ]},

  // ── SUNTORY BAR (Booth #4 — Main Floor) ─────────────────────────────────────
  { name: "El Tesoro", category: "Tequila", website: "https://eltesorotequila.com", table: "Booth #4 · Suntory",
    expressions: [
      { name: "Blanco",   price: 54.99 },
      { name: "Reposado", price: 75.99 },
      { name: "Añejo",    price: 91.99 },
    ]},

  { name: "Hornitos", category: "Tequila", website: "https://hornitostequila.com", table: "Booth #4 · Suntory",
    expressions: [
      { name: "Blanco",    price: 28.99 },
      { name: "Pineapple", price: 28.99 },
      { name: "Añejo",     price: 39.99 },
    ]},

  { name: "Tres Generaciones", category: "Tequila", website: "https://tresgeneraciones.com", table: "Booth #4 · Suntory",
    expressions: [
      { name: "Plata",                       price: 41.99 },
      { name: "Reposado",                    price: 43.99 },
      { name: "Añejo",                       price: 47.99 },
      { name: "Cristalino",                  price: 54.99 },
      { name: "50th Anniversary Añejo",      price: 99.99 },
    ]},

  { name: "Sauza Hacienda", category: "Tequila", website: "https://sauzatequila.com", table: "Booth #4 · Suntory",
    expressions: [
      { name: "Silver", price: 19.49 },
      { name: "Gold",   price: 19.49 },
    ]},

  // ── BF / SUNTORY HEALTH (Booth #5 — Main Floor) ─────────────────────────────
  { name: "El Jimador", category: "Tequila", website: "https://eljimador.com", table: "Booth #5 · BF / Suntory Health",
    expressions: [
      { name: "Silver",   price: 30.99, size: "1L" },
      { name: "Reposado", price: 32.99, size: "1L" },
    ]},

  { name: "Herradura", category: "Tequila", website: "https://herradura.com", table: "Booth #5 · BF / Suntory Health",
    expressions: [
      { name: "Silver",                  price: 43.99, size: "1L" },
      { name: "Reposado",                price: 46.99, size: "1L" },
      { name: "Añejo",                   price: 60.99 },
      { name: "Ultra Añejo",  vip: true, price: 61.99 },
      { name: "Legend Añejo", vip: true, price: 175.99 },
    ]},

  // ── CAMPARI BAR (Booth #7 — Main Floor) ─────────────────────────────────────
  { name: "Espolòn", category: "Tequila", website: "https://espolon.com", table: "Booth #7 · Campari",
    expressions: [
      { name: "Blanco",      price: 30.99 },
      { name: "Reposado",    price: 32.99 },
      { name: "Añejo",       price: 42.99 },
      { name: "Cristalino",  price: 49.99 },
      { name: "Flor de Oro", price: 54.99 },
    ]},

  { name: "Grand Mayenda", category: "Tequila", website: "https://mayendatequila.com", table: "Booth #7 · Campari",
    expressions: [{ name: "Blanco", price: 76.99 }]},

  { name: "Cabo Wabo", category: "Tequila", website: "https://cabowabotequila.com", table: "Booth #7 · Campari",
    expressions: [
      { name: "Blanco",   price: 39.99 },
      { name: "Reposado", price: 44.99 },
      { name: "Añejo",    price: 54.99 },
    ]},

  // ── PROXIMO BAR (Booth #10 — Main Floor) ────────────────────────────────────
  { name: "Cuervo Tradicional", category: "Tequila", website: "https://cuervo.com", table: "Booth #10 · Proximo",
    expressions: [{ name: "Blanco", price: 26.99 }]},

  { name: "1800", category: "Tequila", website: "https://1800tequila.com", table: "Booth #10 · Proximo",
    expressions: [{ name: "Coconut", price: 27.99 }]},

  { name: "Maestro Dobel", category: "Tequila", website: "https://maestrodobel.com", table: "Booth #10 · Proximo",
    expressions: [{ name: "Diamante Cristalino", price: 39.99 }]},

  { name: "Gran Coramino", category: "Tequila", website: "https://grancoramino.com", table: "Booth #10 · Proximo",
    expressions: [{ name: "Reposado", price: 37.99 }]},

  { name: "Gran Centenario", category: "Tequila", website: "https://grancentenario.com", table: "Booth #10 · Proximo",
    expressions: [
      { name: "Reposado", price: 35.99 },
      { name: "Añejo",    price: 41.99 },
    ]},

  { name: "Volcán", category: "Tequila", website: "https://volcandemitierra.com", table: "Booth #10 · Proximo",
    expressions: [
      { name: "Blanco",   price: 50.99 },
      { name: "Reposado", price: 67.99 },
    ]},

  { name: "Xicaru Mezcal", category: "Mezcal", website: "https://xicarumezcal.com", table: "Table 21 · RNDC (3rd Floor Walkway)",
    expressions: [
      { name: "Silver",   price: 35.99 },
      { name: "Reposado", price: 39.99 },
      { name: "Tobalá",   price: 89.99 },
    ]},

  // ── KAPENA POWER (Booth #19 — 3rd Floor Golf) ───────────────────────────────
  { name: "Kapena Spirits", category: "Tequila", website: "https://kapenaspirits.com", table: "Booth #19 · Kapena (3rd Floor Golf)",
    expressions: [
      { name: "Blanco",   vip: true, price: 49.99 },
      { name: "Reposado",            price: 59.99 },
      { name: "Añejo",               price: 69.99 },
      { name: "Li Hing",  vip: true, price: 55.99 },
    ]},

  // ── RNDC (Booth #16 — 3rd Floor Walkway) ────────────────────────────────────
  { name: "Angelisco", category: "Tequila", website: "https://angeliscotequila.com", table: "Booth #16 · RNDC (3rd Floor Walkway)",
    expressions: [{ name: "Tequila", price: 49.99 }]},

  { name: "512 Tequila", category: "Tequila", website: "https://512tequila.com", table: "Table 26 · RNDC (3rd Floor Walkway)",
    expressions: [{ name: "Tequila", price: 43.99 }]},

  { name: "Paladar Tequila", category: "Tequila", website: "https://paladartequila.com", table: "Table 26 · RNDC (3rd Floor Walkway)",
    expressions: [{ name: "Tequila", price: 49.99 }]},

  { name: "Casa Azul", category: "Tequila", website: "https://casaazulspirits.com", table: "Table 26 · RNDC (3rd Floor Walkway)",
    expressions: [{ name: "Tequila", price: 95.99 }]},

  { name: "Mandala", category: "Tequila", website: "https://mandalatequila.com", table: "Table 16 · RNDC (3rd Floor Walkway)",
    expressions: [{ name: "Tequila", price: 109.99 }]},

  { name: "Casa Obsidiana", category: "Tequila", website: "https://casaobsidianatequila.com", table: "Booth #16 · RNDC (3rd Floor Walkway)",
    expressions: [{ name: "Tequila", price: 99.99 }]},

  { name: "3 Tres", category: "Tequila", website: "https://3trestequila.com", table: "Booth #16 · RNDC (3rd Floor Walkway)",
    expressions: [
      { name: "Blanco",              price: 47.99 },
      { name: "Reposado",            price: 52.99 },
      { name: "Añejo",    vip: true, price: 89.99 },
    ]},

  { name: "La Gritona", category: "Tequila", website: "https://lagritona.com", table: "Table 21 · RNDC (3rd Floor Walkway)",
    expressions: [{ name: "Reposado", price: 49.99 }]},

  { name: "Partida", category: "Tequila", website: "https://partidatequila.com", table: "Table 22 · RNDC (3rd Floor Walkway)",
    expressions: [
      { name: "Blanco",                                                            price: 49.99 },
      { name: "Reposado",                                                          price: 56.99 },
      { name: "Añejo",                                                             price: 66.99 },
      { name: "Roble Fino Reposado",   vip: true, price: 116.99, table: "Table 23 · RNDC (3rd Floor Walkway)" },
      { name: "Roble Fino Añejo",      vip: true, price: 126.99, table: "Table 23 · RNDC (3rd Floor Walkway)" },
      { name: "Roble Fino Cristalino", vip: true, price: 116.99, table: "Table 23 · RNDC (3rd Floor Walkway)" },
    ]},

  { name: "Milagro", category: "Tequila", website: "https://milagrotequila.com", table: "Booth #16 · RNDC (3rd Floor Walkway)",
    expressions: [
      { name: "Silver",                                                            price: 31.99 },
      { name: "Reposado",                                                          price: 36.99 },
      { name: "Añejo",                                                             price: 45.99 },
      { name: "Cristalino",                                                        price: 61.99 },
      { name: "Barrel Select Silver",   vip: true, price: 55.99, table: "Table 23 · RNDC (3rd Floor Walkway)" },
      { name: "Barrel Select Reposado", vip: true, price: 62.99, table: "Table 23 · RNDC (3rd Floor Walkway)" },
      { name: "Barrel Select Añejo",    vip: true, price: 75.99, table: "Table 23 · RNDC (3rd Floor Walkway)" },
    ]},

  { name: "Santaleza", category: "Tequila", website: "https://santaleza.com", table: "Table 25 · RNDC (3rd Floor Walkway)",
    expressions: [
      { name: "Blanco",   price: 52.99 },
      { name: "Reposado", price: 62.99 },
      { name: "Añejo",    price: 77.99 },
    ]},

  { name: "Terralta", category: "Tequila", website: "https://tequilaterralta.com", table: "Table 25 · RNDC (3rd Floor Walkway)",
    expressions: [
      { name: "Blanco",            price: 55.99 },
      { name: "Reposado",          price: 61.99 },
      { name: "Añejo",             price: 59.99 },
      { name: "Blanco 110 Proof",  price: 69.99 },
    ]},

  { name: "El Mayor", category: "Tequila", website: "https://elmayor.com", table: "Table 26 · RNDC (3rd Floor Walkway)",
    expressions: [
      { name: "Blanco",   price: 28.99 },
      { name: "Reposado", price: 32.99 },
      { name: "Añejo",    price: 39.99 },
    ]},

  { name: "Exotico", category: "Tequila", website: "https://exoticotequila.com", table: "Table 26 · RNDC (3rd Floor Walkway)",
    expressions: [
      { name: "Silver",   price: 24.99 },
      { name: "Reposado", price: 29.99 },
    ]},

  { name: "400 Conejos", category: "Mezcal", website: "https://400conejos.com", table: "Booth #16 · RNDC (3rd Floor Walkway)",
    expressions: [{ name: "Mezcal Joven", price: 36.99 }]},

  { name: "Agave de Cortés", category: "Mezcal", website: "https://agavedecortes.com", table: "Table 22 · RNDC (3rd Floor Walkway)",
    expressions: [{ name: "Mezcal", price: 55.99 }]},

  { name: "El Jolgorio", category: "Mezcal", website: "https://eljolgorio.com", table: "Booth #16 · RNDC (3rd Floor Walkway)",
    expressions: [{ name: "Mezcal", price: 129.99 }]},

  { name: "Sotol Por Siempre", category: "Sotol", website: "https://sotolporsiempre.com", table: "Booth #16 · RNDC (3rd Floor Walkway)",
    expressions: [{ name: "Sotol", price: 59.99 }]},
];

export default TEQUILA_LINEUP;
